import { Component } from '@angular/core';

// AC-4598: public domiiRescue privacy page linked from the App Store and Google Play listings.
@Component({
  selector: 'app-rescue-privacy',
  templateUrl: './rescue-privacy.component.html',
  styleUrls: ['../rescue-privacy/rescue-legal.scss']
})
export class RescuePrivacyComponent { }
